export const BASE_URL = 'https://myra-portal-10739.botics.co/api/v1';
export const REST_AUTH_BASE_URL = 'https://myra-portal-10739.botics.co';
export const USA_STATE_AND_CITIES = {
  "New York": [
    "New York",
    "Buffalo",
    "Rochester",
    "Yonkers",
    "Syracuse",
    "Albany",
    "New Rochelle",
    "Mount Vernon",
    "Schenectady",
    "Utica",
    "White Plains",
    "Hempstead",
    "Troy",
    "Niagara Falls",
    "Binghamton",
    "Freeport",
    "Valley Stream"
  ],
  "California": [
    "Los Angeles",
    "San Diego",
    "San Jose",
    "San Francisco",
    "Fresno",
    "Sacramento",
    "Long Beach",
    "Oakland",
    "Bakersfield",
    "Anaheim",
    "Santa Ana",
    "Riverside",
    "Stockton",
    "Chula Vista",
    "Irvine",
    "Fremont",
    "San Bernardino",
    "Modesto",
    "Fontana",
    "Oxnard",
    "Moreno Valley",
    "Huntington Beach",
    "Glendale",
    "Santa Clarita",
    "Garden Grove",
    "Oceanside",
    "Rancho Cucamonga",
    "Santa Rosa",
    "Ontario",
    "Lancaster",
    "Elk Grove",
    "Corona",
    "Palmdale",
    "Salinas",
    "Pomona",
    "Hayward",
    "Escondido",
    "Torrance",
    "Sunnyvale",
    "Orange",
    "Fullerton",
    "Pasadena",
    "Thousand Oaks",
    "Visalia",
    "Simi Valley",
    "Concord",
    "Roseville",
    "Victorville",
    "Santa Clara",
    "Vallejo",
    "Berkeley",
    "El Monte",
    "Downey",
    "Costa Mesa",
    "Inglewood",
    "Carlsbad",
    "San Buenaventura (Ventura)",
    "Fairfield",
    "West Covina",
    "Murrieta",
    "Richmond",
    "Norwalk",
    "Antioch",
    "Temecula",
    "Burbank",
    "Daly City",
    "Rialto",
    "Santa Maria",
    "El Cajon",
    "San Mateo",
    "Clovis",
    "Compton",
    "Jurupa Valley",
    "Vista",
    "South Gate",
    "Mission Viejo",
    "Vacaville",
    "Carson",
    "Hesperia",
    "Santa Monica",
    "Westminster",
    "Redding",
    "Santa Barbara",
    "Chico",
    "Newport Beach",
    "San Leandro",
    "San Marcos",
    "Whittier",
    "Hawthorne",
    "Citrus Heights",
    "Tracy",
    "Alhambra",
    "Livermore",
    "Buena Park",
    "Menifee",
    "Hemet",
    "Lakewood",
    "Merced",
    "Chino",
    "Indio",
    "Redwood City",
    "Lake Forest",
    "Napa",
    "Tustin",
    "Bellflower",
    "Mountain View",
    "Chino Hills",
    "Baldwin Park",
    "Alameda",
    "Upland",
    "San Ramon",
    "Folsom",
    "Pleasanton",
    "Union City",
    "Perris",
    "Manteca",
    "Lynwood",
    "Apple Valley",
    "Redlands",
    "Turlock",
    "Milpitas",
    "Redondo Beach",
    "Rancho Cordova",
    "Yorba Linda",
    "Palo Alto",
    "Davis",
    "Camarillo",
    "Walnut Creek",
    "Pittsburg",
    "South San Francisco",
    "Yuba City",
    "San Clemente",
    "Laguna Niguel",
    "Pico Rivera",
    "Montebello",
    "Lodi",
    "Madera",
    "Santa Cruz",
    "La Habra",
    "Encinitas",
    "Monterey Park",
    "Tulare",
    "Cupertino",
    "Gardena",
    "National City",
    "Rocklin",
    "Petaluma",
    "Huntington Park",
    "San Rafael",
    "La Mesa",
    "Arcadia",
    "Fountain Valley",
    "Diamond Bar",
    "Woodland",
    "Santee",
    "Lake Elsinore",
    "Porterville",
    "Paramount",
    "Eastvale",
    "Rosemead",
    "Hanford",
    "Highland",
    "Brentwood",
    "Novato",
    "Colton",
    "Cathedral City",
    "Delano",
    "Yucaipa",
    "Watsonville",
    "Placentia",
    "Glendora",
    "Gilroy",
    "Palm Desert",
    "Cerritos",
    "West Sacramento",
    "Aliso Viejo",
    "Poway",
    "La Mirada",
    "Rancho Santa Margarita",
    "Cypress",
    "Dublin",
    "Covina",
    "Azusa",
    "Palm Springs",
    "San Luis Obispo",
    "Ceres",
    "San Jacinto",
    "Lincoln",
    "Newark",
    "Lompoc",
    "El Centro",
    "Danville",
    "Bell Gardens",
    "Coachella",
    "Rancho Palos Verdes",
    "San Bruno",
    "Rohnert Park",
    "Brea",
    "La Puente",
    "Campbell",
    "San Gabriel",
    "Beaumont",
    "Morgan Hill",
    "Culver City",
    "Calexico",
    "Stanton",
    "La Quinta",
    "Pacifica",
    "Montclair",
    "Oakley",
    "Monrovia",
    "Los Banos",
    "Martinez"
  ],
  "Illinois": [
    "Chicago",
    "Aurora",
    "Rockford",
    "Joliet",
    "Naperville",
    "Springfield",
    "Peoria",
    "Elgin",
    "Waukegan",
    "Cicero",
    "Champaign",
    "Bloomington",
    "Arlington Heights",
    "Evanston",
    "Decatur",
    "Schaumburg",
    "Bolingbrook",
    "Palatine",
    "Skokie",
    "Des Plaines",
    "Orland Park",
    "Tinley Park",
    "Oak Lawn",
    "Berwyn",
    "Mount Prospect",
    "Normal",
    "Wheaton",
    "Hoffman Estates",
    "Oak Park",
    "Downers Grove",
    "Elmhurst",
    "Glenview",
    "DeKalb",
    "Lombard",
    "Belleville",
    "Moline",
    "Buffalo Grove",
    "Bartlett",
    "Urbana",
    "Quincy",
    "Crystal Lake",
    "Plainfield",
    "Streamwood",
    "Carol Stream",
    "Romeoville",
    "Rock Island",
    "Hanover Park",
    "Carpentersville",
    "Wheeling",
    "Park Ridge",
    "Addison",
    "Calumet City"
  ],
  "Texas": [
    "Houston",
    "San Antonio",
    "Dallas",
    "Austin",
    "Fort Worth",
    "El Paso",
    "Arlington",
    "Corpus Christi",
    "Plano",
    "Laredo",
    "Lubbock",
    "Garland",
    "Irving",
    "Amarillo",
    "Grand Prairie",
    "Brownsville",
    "Pasadena",
    "McKinney",
    "Mesquite",
    "McAllen",
    "Killeen",
    "Frisco",
    "Waco",
    "Carrollton",
    "Denton",
    "Midland",
    "Abilene",
    "Beaumont",
    "Round Rock",
    "Odessa",
    "Wichita Falls",
    "Richardson",
    "Lewisville",
    "Tyler",
    "College Station",
    "Pearland",
    "San Angelo",
    "Allen",
    "League City",
    "Sugar Land",
    "Longview",
    "Edinburg",
    "Mission",
    "Bryan",
    "Baytown",
    "Pharr",
    "Temple",
    "Missouri City",
    "Flower Mound",
    "Harlingen",
    "North Richland Hills",
    "Victoria",
    "Conroe",
    "New Braunfels",
    "Mansfield",
    "Cedar Park",
    "Rowlett",
    "Port Arthur",
    "Euless",
    "Georgetown",
    "Pflugerville",
    "DeSoto",
    "San Marcos",
    "Grapevine",
    "Bedford",
    "Galveston",
    "Cedar Hill",
    "Texas City",
    "Wylie",
    "Haltom City",
    "Keller",
    "Coppell",
    "Rockwall",
    "Huntsville",
    "Duncanville",
    "Sherman",
    "The Colony",
    "Burleson",
    "Hurst",
    "Lancaster",
    "Texarkana",
    "Friendswood",
    "Weslaco"
  ],
  "Pennsylvania": [
    "Philadelphia",
    "Pittsburgh",
    "Allentown",
    "Erie",
    "Reading",
    "Scranton",
    "Bethlehem",
    "Lancaster",
    "Harrisburg",
    "Altoona",
    "York",
    "State College",
    "Wilkes-Barre"
  ],
  "Arizona": [
    "Phoenix",
    "Tucson",
    "Mesa",
    "Chandler",
    "Glendale",
    "Scottsdale",
    "Gilbert",
    "Tempe",
    "Peoria",
    "Surprise",
    "Yuma",
    "Avondale",
    "Goodyear",
    "Flagstaff",
    "Buckeye",
    "Lake Havasu City",
    "Casa Grande",
    "Sierra Vista",
    "Maricopa",
    "Oro Valley",
    "Prescott",
    "Bullhead City",
    "Prescott Valley",
    "Marana",
    "Apache Junction"
  ],
  "Florida": [
    "Jacksonville",
    "Miami",
    "Tampa",
    "Orlando",
    "St. Petersburg",
    "Hialeah",
    "Tallahassee",
    "Fort Lauderdale",
    "Port St. Lucie",
    "Cape Coral",
    "Pembroke Pines",
    "Hollywood",
    "Miramar",
    "Gainesville",
    "Coral Springs",
    "Miami Gardens",
    "Clearwater",
    "Palm Bay",
    "Pompano Beach",
    "West Palm Beach",
    "Lakeland",
    "Davie",
    "Miami Beach",
    "Sunrise",
    "Plantation",
    "Boca Raton",
    "Deltona",
    "Largo",
    "Deerfield Beach",
    "Palm Coast",
    "Melbourne",
    "Boynton Beach",
    "Lauderhill",
    "Weston",
    "Fort Myers",
    "Kissimmee",
    "Homestead",
    "Tamarac",
    "Delray Beach",
    "Daytona Beach",
    "North Miami",
    "Wellington",
    "North Port",
    "Jupiter",
    "Ocala",
    "Port Orange",
    "Margate",
    "Coconut Creek",
    "Sanford",
    "Sarasota",
    "Pensacola",
    "Bradenton",
    "Palm Beach Gardens",
    "Pinellas Park",
    "Coral Gables",
    "Doral",
    "Bonita Springs",
    "Apopka",
    "Titusville",
    "North Miami Beach",
    "Oakland Park",
    "Fort Pierce",
    "North Lauderdale",
    "Cutler Bay",
    "Altamonte Springs",
    "St. Cloud",
    "Greenacres",
    "Ormond Beach",
    "Ocoee",
    "Hallandale Beach",
    "Winter Garden",
    "Aventura"
  ],
  "Indiana": [
    "Indianapolis",
    "Fort Wayne",
    "Evansville",
    "South Bend",
    "Carmel",
    "Bloomington",
    "Fishers",
    "Hammond",
    "Gary",
    "Muncie",
    "Lafayette",
    "Terre Haute",
    "Kokomo",
    "Anderson",
    "Noblesville",
    "Greenwood",
    "Elkhart",
    "Mishawaka",
    "Lawrence",
    "Jeffersonville",
    "Columbus",
    "Portage"
  ],
  "Ohio": [
    "Columbus",
    "Cleveland",
    "Cincinnati",
    "Toledo",
    "Akron",
    "Dayton",
    "Parma",
    "Canton",
    "Youngstown",
    "Lorain",
    "Hamilton",
    "Springfield",
    "Kettering",
    "Elyria",
    "Lakewood",
    "Cuyahoga Falls",
    "Middletown",
    "Euclid",
    "Newark",
    "Mansfield",
    "Mentor",
    "Beavercreek",
    "Cleveland Heights",
    "Strongsville",
    "Dublin",
    "Fairfield",
    "Findlay",
    "Warren",
    "Lancaster",
    "Lima",
    "Huber Heights",
    "Westerville",
    "Marion",
    "Grove City"
  ],
  "North Carolina": [
    "Charlotte",
    "Raleigh",
    "Greensboro",
    "Durham",
    "Winston-Salem",
    "Fayetteville",
    "Cary",
    "Wilmington",
    "High Point",
    "Greenville",
    "Asheville",
    "Concord",
    "Gastonia",
    "Jacksonville",
    "Chapel Hill",
    "Rocky Mount",
    "Burlington",
    "Wilson",
    "Huntersville",
    "Kannapolis",
    "Apex",
    "Hickory",
    "Goldsboro"
  ],
  "Michigan": [
    "Detroit",
    "Grand Rapids",
    "Warren",
    "Sterling Heights",
    "Ann Arbor",
    "Lansing",
    "Flint",
    "Dearborn",
    "Livonia",
    "Westland",
    "Troy",
    "Farmington Hills",
    "Kalamazoo",
    "Wyoming",
    "Southfield",
    "Rochester Hills",
    "Taylor",
    "Pontiac",
    "St. Clair Shores",
    "Royal Oak",
    "Novi",
    "Dearborn Heights",
    "Battle Creek",
    "Saginaw",
    "Kentwood",
    "East Lansing",
    "Roseville",
    "Portage",
    "Midland",
    "Lincoln Park",
    "Muskegon"
  ],
  "Tennessee": [
    "Memphis",
    "Nashville-Davidson",
    "Knoxville",
    "Chattanooga",
    "Clarksville",
    "Murfreesboro",
    "Jackson",
    "Franklin",
    "Johnson City",
    "Bartlett",
    "Hendersonville",
    "Kingsport",
    "Collierville",
    "Cleveland",
    "Smyrna",
    "Germantown",
    "Brentwood"
  ],
  "Massachusetts": [
    "Boston",
    "Worcester",
    "Springfield",
    "Lowell",
    "Cambridge",
    "New Bedford",
    "Brockton",
    "Quincy",
    "Lynn",
    "Fall River",
    "Newton",
    "Lawrence",
    "Somerville",
    "Waltham",
    "Haverhill",
    "Malden",
    "Medford",
    "Taunton",
    "Chicopee",
    "Weymouth Town",
    "Revere",
    "Peabody",
    "Methuen",
    "Barnstable Town",
    "Pittsfield",
    "Attleboro",
    "Everett",
    "Salem",
    "Westfield",
    "Leominster",
    "Fitchburg",
    "Beverly",
    "Holyoke",
    "Marlborough",
    "Woburn",
    "Chelsea"
  ],
  "Washington": [
    "Seattle",
    "Spokane",
    "Tacoma",
    "Vancouver",
    "Bellevue",
    "Kent",
    "Everett",
    "Renton",
    "Yakima",
    "Federal Way",
    "Spokane Valley",
    "Bellingham",
    "Kennewick",
    "Auburn",
    "Pasco",
    "Marysville",
    "Lakewood",
    "Redmond",
    "Shoreline",
    "Richland",
    "Kirkland",
    "Burien",
    "Sammamish",
    "Olympia",
    "Lacey",
    "Edmonds",
    "Bremerton",
    "Puyallup"
  ],
  "Colorado": [
    "Denver",
    "Colorado Springs",
    "Aurora",
    "Fort Collins",
    "Lakewood",
    "Thornton",
    "Arvada",
    "Westminster",
    "Pueblo",
    "Centennial",
    "Boulder",
    "Greeley",
    "Longmont",
    "Loveland",
    "Grand Junction",
    "Broomfield",
    "Castle Rock",
    "Commerce City",
    "Parker",
    "Littleton",
    "Northglenn"
  ],
  "District of Columbia": [
    "Washington"
  ],
  "Maryland": [
    "Baltimore",
    "Frederick",
    "Rockville",
    "Gaithersburg",
    "Bowie",
    "Hagerstown",
    "Annapolis"
  ],
  "Kentucky": [
    "Louisville/Jefferson County",
    "Lexington-Fayette",
    "Bowling Green",
    "Owensboro",
    "Covington"
  ],
  "Oregon": [
    "Portland",
    "Eugene",
    "Salem",
    "Gresham",
    "Hillsboro",
    "Beaverton",
    "Bend",
    "Medford",
    "Springfield",
    "Corvallis",
    "Albany",
    "Tigard",
    "Lake Oswego",
    "Keizer"
  ],
  "Oklahoma": [
    "Oklahoma City",
    "Tulsa",
    "Norman",
    "Broken Arrow",
    "Lawton",
    "Edmond",
    "Moore",
    "Midwest City",
    "Enid",
    "Stillwater",
    "Muskogee"
  ],
  "Wisconsin": [
    "Milwaukee",
    "Madison",
    "Green Bay",
    "Kenosha",
    "Racine",
    "Appleton",
    "Waukesha",
    "Eau Claire",
    "Oshkosh",
    "Janesville",
    "West Allis",
    "La Crosse",
    "Sheboygan",
    "Wauwatosa",
    "Fond du Lac",
    "New Berlin",
    "Wausau",
    "Brookfield",
    "Greenfield",
    "Beloit"
  ],
  "Nevada": [
    "Las Vegas",
    "Henderson",
    "Reno",
    "North Las Vegas",
    "Sparks",
    "Carson City"
  ],
  "New Mexico": [
    "Albuquerque",
    "Las Cruces",
    "Rio Rancho",
    "Santa Fe",
    "Roswell",
    "Farmington",
    "Clovis"
  ],
  "Missouri": [
    "Kansas City",
    "St. Louis",
    "Springfield",
    "Independence",
    "Columbia",
    "Lee's Summit",
    "O'Fallon",
    "St. Joseph",
    "St. Charles",
    "St. Peters",
    "Blue Springs",
    "Florissant",
    "Joplin",
    "Chesterfield",
    "Jefferson City",
    "Cape Girardeau"
  ],
  "Virginia": [
    "Virginia Beach",
    "Norfolk",
    "Chesapeake",
    "Richmond",
    "Newport News",
    "Alexandria",
    "Hampton",
    "Roanoke",
    "Portsmouth",
    "Suffolk",
    "Lynchburg",
    "Harrisonburg",
    "Leesburg",
    "Charlottesville",
    "Danville",
    "Blacksburg",
    "Manassas"
  ],
  "Georgia": [
    "Atlanta",
    "Columbus",
    "Augusta-Richmond County",
    "Savannah",
    "Athens-Clarke County",
    "Sandy Springs",
    "Roswell",
    "Macon",
    "Johns Creek",
    "Albany",
    "Warner Robins",
    "Alpharetta",
    "Marietta",
    "Valdosta",
    "Smyrna",
    "Dunwoody"
  ],
  "Nebraska": [
    "Omaha",
    "Lincoln",
    "Bellevue",
    "Grand Island"
  ],
  "Minnesota": [
    "Minneapolis",
    "St. Paul",
    "Rochester",
    "Duluth",
    "Bloomington",
    "Brooklyn Park",
    "Plymouth",
    "St. Cloud",
    "Eagan",
    "Woodbury",
    "Maple Grove",
    "Eden Prairie",
    "Coon Rapids",
    "Burnsville",
    "Blaine",
    "Lakeville",
    "Minnetonka",
    "Apple Valley",
    "Edina",
    "St. Louis Park",
    "Mankato",
    "Maplewood",
    "Moorhead",
    "Shakopee"
  ],
  "Kansas": [
    "Wichita",
    "Overland Park",
    "Kansas City",
    "Olathe",
    "Topeka",
    "Lawrence",
    "Shawnee",
    "Manhattan",
    "Lenexa",
    "Salina",
    "Hutchinson"
  ],
  "Louisiana": [
    "New Orleans",
    "Baton Rouge",
    "Shreveport",
    "Lafayette",
    "Lake Charles",
    "Kenner",
    "Bossier City",
    "Monroe",
    "Alexandria"
  ],
  "Hawaii": [
    "Honolulu"
  ],
  "Alaska": [
    "Anchorage"
  ],
  "New Jersey": [
    "Newark",
    "Jersey City",
    "Paterson",
    "Elizabeth",
    "Clifton",
    "Trenton",
    "Camden",
    "Passaic",
    "Union City",
    "Bayonne",
    "East Orange",
    "Vineland",
    "New Brunswick",
    "Hoboken",
    "Perth Amboy",
    "West New York",
    "Plainfield",
    "Hackensack",
    "Sayreville",
    "Kearny",
    "Linden",
    "Atlantic City"
  ],
  "Idaho": [
    "Boise City",
    "Nampa",
    "Meridian",
    "Idaho Falls",
    "Pocatello",
    "Caldwell",
    "Coeur d'Alene",
    "Twin Falls"
  ],
  "Alabama": [
    "Birmingham",
    "Montgomery",
    "Mobile",
    "Huntsville",
    "Tuscaloosa",
    "Hoover",
    "Dothan",
    "Auburn",
    "Decatur",
    "Madison",
    "Florence",
    "Gadsden"
  ],
  "Iowa": [
    "Des Moines",
    "Cedar Rapids",
    "Davenport",
    "Sioux City",
    "Iowa City",
    "Waterloo",
    "Council Bluffs",
    "Ames",
    "West Des Moines",
    "Dubuque",
    "Ankeny",
    "Urbandale",
    "Cedar Falls"
  ],
  "Arkansas": [
    "Little Rock",
    "Fort Smith",
    "Fayetteville",
    "Springdale",
    "Jonesboro",
    "North Little Rock",
    "Conway",
    "Rogers",
    "Pine Bluff",
    "Bentonville"
  ],
  "Utah": [
    "Salt Lake City",
    "West Valley City",
    "Provo",
    "West Jordan",
    "Orem",
    "Sandy",
    "Ogden",
    "St. George",
    "Layton",
    "Taylorsville",
    "South Jordan",
    "Lehi",
    "Logan",
    "Murray",
    "Draper",
    "Bountiful",
    "Riverton",
    "Roy"
  ],
  "Rhode Island": [
    "Providence",
    "Warwick",
    "Cranston",
    "Pawtucket",
    "East Providence",
    "Woonsocket"
  ],
  "Mississippi": [
    "Jackson",
    "Gulfport",
    "Southaven",
    "Hattiesburg",
    "Biloxi",
    "Meridian"
  ],
  "South Dakota": [
    "Sioux Falls",
    "Rapid City"
  ],
  "Connecticut": [
    "Bridgeport",
    "New Haven",
    "Stamford",
    "Hartford",
    "Waterbury",
    "Norwalk",
    "Danbury",
    "New Britain",
    "Meriden",
    "Bristol",
    "West Haven",
    "Milford",
    "Middletown",
    "Norwich",
    "Shelton"
  ],
  "South Carolina": [
    "Columbia",
    "Charleston",
    "North Charleston",
    "Mount Pleasant",
    "Rock Hill",
    "Greenville",
    "Summerville",
    "Sumter",
    "Goose Creek",
    "Hilton Head Island",
    "Florence",
    "Spartanburg"
  ],
  "New Hampshire": [
    "Manchester",
    "Nashua",
    "Concord"
  ],
  "North Dakota": [
    "Fargo",
    "Bismarck",
    "Grand Forks",
    "Minot"
  ],
  "Montana": [
    "Billings",
    "Missoula",
    "Great Falls",
    "Bozeman"
  ],
  "Delaware": [
    "Wilmington",
    "Dover"
  ],
  "Maine": [
    "Portland"
  ],
  "Wyoming": [
    "Cheyenne",
    "Casper"
  ],
  "West Virginia": [
    "Charleston",
    "Huntington"
  ],
  "Vermont": [
    "Burlington"
  ]
};
export const COUNTIES = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'AndorrA', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Cote D\'Ivoire', code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Lao People\'S Democratic Republic', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'RWANDA', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' }
];
export const RISK_RETURN_EXPECTATION = {
  '5': [
    {
      target: '0%',
      ticker: 'SPTM',
      description: 'Portfolio Total Stock Market ETF'
    },
    {
      target: '0%',
      ticker: 'SLYV',
      description: 'S&P 600 Small Cap Value ETF'
    },
    {
      target: '0%',
      ticker: 'SPDW',
      description: 'Portfolio Developed World ex-US ETF'
    },
    {
      target: '0%',
      ticker: 'SPEM',
      description: 'Portfolio Emerging Markets ETF'
    },
    {
      target: '0%',
      ticker: 'RWO',
      description: 'DJ Wilshire Global Real Estate ETF'
    },
    {
      target: '0%',
      ticker: 'GWX',
      description: 'S&P International Small Cap ETF'
    },
    {
      target: '70%',
      ticker: 'MUB',
      description: 'iShares National AMT-Free Muni Bond'
    },
    {
      target: '30%',
      ticker: 'SUB',
      description: 'iShares ST National AMT Free Muni Bond'
    }
  ],
  '10': [
    {
      target: '7%',
      ticker: 'SPTM',
      description: 'Portfolio Total Stock Market ETF'
    },
    {
      target: '4%',
      ticker: 'SLYV',
      description: 'S&P 600 Small Cap Value ETF'
    },
    {
      target: '3%',
      ticker: 'SPDW',
      description: 'Portfolio Developed World ex-US ETF'
    },
    {
      target: '2%',
      ticker: 'SPEM',
      description: 'Portfolio Emerging Markets ETF'
    },
    {
      target: '2%',
      ticker: 'RWO',
      description: 'DJ Wilshire Global Real Estate ETF'
    },
    {
      target: '2%',
      ticker: 'GWX',
      description: 'S&P International Small Cap ETF'
    },
    {
      target: '56%',
      ticker: 'MUB',
      description: 'iShares National AMT-Free Muni Bond'
    },
    {
      target: '24%',
      ticker: 'SUB',
      description: 'iShares ST National AMT Free Muni Bond'
    }
  ],
  '15': [
    {
      target: '14%',
      ticker: 'SPTM',
      description: 'Portfolio Total Stock Market ETF'
    },
    {
      target: '8%',
      ticker: 'SLYV',
      description: 'S&P 600 Small Cap Value ETF'
    },
    {
      target: '6%',
      ticker: 'SPDW',
      description: 'Portfolio Developed World ex-US ETF'
    },
    {
      target: '4%',
      ticker: 'SPEM',
      description: 'Portfolio Emerging Markets ETF'
    },
    {
      target: '4%',
      ticker: 'RWO',
      description: 'DJ Wilshire Global Real Estate ETF'
    },
    {
      target: '4%',
      ticker: 'GWX',
      description: 'S&P International Small Cap ETF'
    },
    {
      target: '42%',
      ticker: 'MUB',
      description: 'iShares National AMT-Free Muni Bond'
    },
    {
      target: '18%',
      ticker: 'SUB',
      description: 'iShares ST National AMT Free Muni Bond'
    }
  ],
  '20': [
    {
      target: '21%',
      ticker: 'SPTM',
      description: 'Portfolio Total Stock Market ETF'
    },
    {
      target: '12%',
      ticker: 'SLYV',
      description: 'S&P 600 Small Cap Value ETF'
    },
    {
      target: '9%',
      ticker: 'SPDW',
      description: 'Portfolio Developed World ex-US ETF'
    },
    {
      target: '6%',
      ticker: 'SPEM',
      description: 'Portfolio Emerging Markets ETF'
    },
    {
      target: '6%',
      ticker: 'RWO',
      description: 'DJ Wilshire Global Real Estate ETF'
    },
    {
      target: '6%',
      ticker: 'GWX',
      description: 'S&P International Small Cap ETF'
    },
    {
      target: '28%',
      ticker: 'MUB',
      description: 'iShares National AMT-Free Muni Bond'
    },
    {
      target: '12%',
      ticker: 'SUB',
      description: 'iShares ST National AMT Free Muni Bond'
    }
  ],
  '25': [
    {
      target: '28%',
      ticker: 'SPTM',
      description: 'Portfolio Total Stock Market ETF'
    },
    {
      target: '16%',
      ticker: 'SLYV',
      description: 'S&P 600 Small Cap Value ETF'
    },
    {
      target: '12%',
      ticker: 'SPDW',
      description: 'Portfolio Developed World ex-US ETF'
    },
    {
      target: '8%',
      ticker: 'SPEM',
      description: 'Portfolio Emerging Markets ETF'
    },
    {
      target: '8%',
      ticker: 'RWO',
      description: 'DJ Wilshire Global Real Estate ETF'
    },
    {
      target: '8%',
      ticker: 'GWX',
      description: 'S&P International Small Cap ETF'
    },
    {
      target: '14%',
      ticker: 'MUB',
      description: 'iShares National AMT-Free Muni Bond'
    },
    {
      target: '6%',
      ticker: 'SUB',
      description: 'iShares ST National AMT Free Muni Bond'
    }
  ],
  '30': [
    {
      target: '35%',
      ticker: 'SPTM',
      description: 'Portfolio Total Stock Market ETF'
    },
    {
      target: '20%',
      ticker: 'SLYV',
      description: 'S&P 600 Small Cap Value ETF'
    },
    {
      target: '15%',
      ticker: 'SPDW',
      description: 'Portfolio Developed World ex-US ETF'
    },
    {
      target: '10%',
      ticker: 'SPEM',
      description: 'Portfolio Emerging Markets ETF'
    },
    {
      target: '10%',
      ticker: 'RWO',
      description: 'DJ Wilshire Global Real Estate ETF'
    },
    {
      target: '10%',
      ticker: 'GWX',
      description: 'S&P International Small Cap ETF'
    },
    {
      target: '0%',
      ticker: 'MUB',
      description: 'iShares National AMT-Free Muni Bond'
    },
    {
      target: '0%',
      ticker: 'SUB',
      description: 'iShares ST National AMT Free Muni Bond'
    }
  ],
};
export const OCCUPATIONS = [
  'A42 Accountant/Auditor/Bookkeeper',
  'A62 Adjuster',
  'A82 Advertiser/Marketer/PR Professional',
  'A33 Air Traffic Controller',
  'A43 Ambassador/Consulate Professional',
  'A53 Analyst',
  'A63 Appraiser',
  'A73 Architect/Designer',
  'A83 Artist/Performer/Actor/Dancer',
  'A93 Assistant/Executive Assistant',
  'A44 Athlete',
  'A64 Attorney/Judge/Legal Professional',
  'A74 Auctioneer',
  'L51 Banker/Lending Professional',
  'B21 Barber/Beautician/Hairstylist',
  'B31 Broker/Registered Rep',
  'B41 Business Executive (VP, Director, etc.)',
  'B51 Business Owner',
  'C81 Caregiver',
  'C91 Carpenter/Construction Worker/Contractor',
  'C22 Cashier',
  'C32 Chef/Cook',
  'C42 Chiropractor',
  'C52 Civil Servant',
  'C62 Clergy',
  'C72 Clerk',
  'C82 Compliance/Regulatory Professional',
  'C92 Consultant',
  'C43 Counselor/Therapist',
  'C53 Customer Service Representative',
  'D11 Dealer',
  'D61 Dentist',
  'D31 Distributor',
  'D41 Doctor/Surgeon/Physician',
  'D51 Driver',
  'E51 Engineer',
  'E71 Exterminator',
  'F71 Factory/Warehouse Worker',
  'F81 Farmer/Rancher',
  'F91 Financial Planner/Advisor',
  'F22 Flight Attendant',
  'F32 Human Resources Professional',
  'I41 Importer/Exporter',
  'I51 Inspector/Investigator',
  'I81 Investor',
  'I91 IT Professional/IT Associate',
  'J31 Janitor',
  'J41 Jeweler',
  'L31 Laborer',
  'L41 Landscaper',
  'M91 Mechanic',
  'M22 Military, Officer or Associated',
  'M32 Mortician/Funeral Director',
  'N21 Nurse',
  'O11 Office Associate',
  'O21 Other',
  'P81 Pharmacist',
  'P91 Physical Therapist',
  'P22 Pilot',
  'P32 Police Officer/Firefighter/Law Enforcement Professional',
  'P42 Politician',
  'P52 Project Manager',
  'R81 Real Estate Professional',
  'R71 Researcher',
  'S41 Salesperson',
  'S51 Scientist',
  'S61 Seamstress/Tailor',
  'S71 Security Guard',
  'S81 Social Worker',
  'T41 Teacher/Professor',
  'T51 Technician',
  'T61 Teller',
  'T71 Tradesperson/Craftsperson',
  'T81 Trainer/Instructor',
  'U21 Underwriter',
  'V11 Veterinarian',
  'W21 Writer/Journalist/Editor'
];
export const INDUSTRIES = [
  'A11 Accounting',
  'A21 Advertising/Marketing',
  'A31 Aerospace/Defense',
  'A41 Agriculture/Forestry',
  'A51 Amusement and Recreation',
  'A61 Animal Services and Veterinary',
  'A71 Architecture/Design',
  'A81 Arts/Antiques',
  'A91 Athletics/Fitness',
  'A32 Automotive',
  'B11 Aviation',
  'C11 Bar/Nightclub/Adult Entertainment Club',
  'C21 Childcare',
  'C31 Cleaning/Janitorial/Housekeeping',
  'C41 Communications/Telecommunications',
  'C51 Construction/Carpentry/Landscaping',
  'C61 Convenience Store/Liquor Store/Gas Station',
  'C71 Customer Service and Support',
  'E11 Education',
  'E21 Embassy/Consulate',
  'E31 Energy',
  'E41 Engineering',
  'F11 Fashion/Clothing',
  'F21 Financial Services',
  'F51 Firearms and Explosives',
  'G11 Gaming/Casino/Card Club',
  'G21 Government/Public Administration',
  'G31 Grocery/Supermarket',
  'H11 Healthcare/Medical Services',
  'H21 Hotel/Hospitality',
  'I11 Import/Export',
  'I21 Information Technology (IT)',
  'I31 Insurance',
  'J11 Jewelry, Gems, and Precious Metals',
  'L11 Legal Services/Public Safety',
  'L21 Logistics/Supply Chain',
  'M11 Manufacturing',
  'M21 Maritime',
  'M31 Media/Entertainment',
  'M41 Mining, Oil, and Gas',
  'M51 Money Services Businesses (Check Cashing, Money Transmitting, Payday Loans, Currency Exchange)',
  'N11 Non-Profit/NGO (Non-Government Agency)/Charity',
  'O31 Other',
  'P11 Parking and Car Washes',
  'P21 Pawn Shops/Brokers',
  'P31 Personal Care/Hygiene (Beauty,Salon, Cosmetics, Massage, etc.)',
  'P41 Pharmaceuticals',
  'P51 Printing/Publishing',
  'P71 Professional/Civic Organizations (Non-Retail)',
  'R11 Real Estate',
  'R21 Religious Organization',
  'R31 Repair Services - Home, Auto, and Other',
  'R41 Restaurant/Food Service',
  'R51 Retail Sales/Retail Trade',
  'S11 Science and Biotechnology',
  'S21 Security',
  'T11 Transportation',
  'T31 Travel',
  'U11 Utilities (Public)',
  'W11 Wholesale Sales/Trade'
];
export const NON_IMMIGRANT_VISA_TYPES = [
  'B-1: Athlete, amateur or professional (competing for prize money only)',
  'J: Au pair (exchange visitor)',
  'E-3: Australian professional specialty',
  'BCC: Border Crossing Card: Mexico',
  'B-1: Business visitor',
  'CW-1: CNMI-only transitional worker',
  'D: Crewmember',
  'A: Diplomat or foreign government official',
  'B-1: Domestic employee or nanny - must be accompanying a foreign national employer',
  'G1-G5, NATO: Employee of a designated international organization or NATO',
  'J: Exchange visitor',
  'A-2, NATO1-6: Foreign military personnel stationed in the United States',
  'O: Foreign national with extraordinary ability in Sciences, Arts, Education, Business or Athletics',
  'H-1B1: Free Trade Agreement (FTA) Professional: Chile, Singapore',
  'Q: International cultural exchange visitor',
  'L: Intra-company transferee',
  'B-2: Medical treatment, visitor for',
  'I: Media, journalist',
  'TN/TD: NAFTA professional worker: Mexico, Canada',
  'P: Performing athlete, artist, entertainer',
  'J , H-1B: Physician',
  'J: Professor, scholar, teacher (exchange visitor)',
  'R: Religious worker',
  'H-1B: Specialty occupations in fields requiring highly specialized knowledge',
  'F, M: Student: academic, vocational',
  'H-2A: Temporary agricultural worker',
  'H-2B: Temporary worker performing other services or labor of a temporary or seasonal nature.',
  'B-2: Tourism, vacation, pleasure visitor',
  'H-3: Training in a program not primarily for employment',
  'E: Treaty trader/treaty investor',
  'C: Transiting the United States',
  'U: Victim of Criminal Activity',
  'T: Victim of Human Trafficking',
  'V: Nonimmigrant (V) Visa for Spouse and Children of a Lawful Permanent Resident (LPR)'
];
export const IMMIGRANT_VISA_TYPES = [
  'IR1, CR1: Spouse of a U.S. Citizen',
  'K-3: Spouse of a U.S. Citizen awaiting approval of an I-130 immigrant petition',
  'K-1: Fiancé(e) to marry U.S. Citizen & live in U.S.',
  'IR3, IH3, IR4, IH4: Intercountry Adoption of Orphan Children by U.S. Citizens',
  'IR2, CR2, IR5, F1, F3, F4: Certain Family Members of U.S. Citizens',
  'F2A, F2B: Certain Family Members of Lawful Permanent Residents',
  'E1: Priority workers [First]',
  'E2: Professionals Holding Advanced Degrees and Persons of Exceptional Ability [Second]',
  'E3, EW3: Professionals and Other Workers [Third]',
  'S: Certain Special Immigrants: [Fourth]',
  'C5, T5, R5, I5: Employment Creation/Investors [Fifth]',
  'SD, SR: Religious Workers',
  'SI: Iraqi and Afghan Translators/Interpreters',
  'SQ: Iraqis Who Worked for/on Behalf of the U.S. Government',
  'SQ: Afghans Who Worked for/on Behalf of the U.S. Government',
  'DV: Diversity Immigrant Visa', 'SB: Returning Resident'
];
export const SOURCE_OF_FUNDS = [
  'Employment/Wages',
  'Inheritance/Trust',
  'Lottery/Gambling',
  'Retirement Funds',
  'Investments',
  'Spousal/Parental Support',
  'Gift',
  'Unemployment/Disability',
  'Savings',
  'Legal Settlement',
  'Other'
];
